module.exports = __webpack_public_path__ + "static/media/lesson-sound.8be4c32e.png";